// extracted by mini-css-extract-plugin
export default {"zoomModal":"p1-z","image":"q1-z","button":"r1-z","isOverlayShown":"s1-z"};